'use strict';

//Преобразует дату из маски формата dd.mm.yyyy в формат ISO yyyy-mm-dd
function convertsDateToIsoFormat(date) {
    let newDate;
    newDate = date.split('.').reverse().join('-')

    return newDate
}

//Проверяет, входит ли дата в нужный промежуток дат
function checkDataPeriod(date, start, end) {
    const dateTime = new Date(convertsDateToIsoFormat(date)).getTime()
    const startTime = new Date(convertsDateToIsoFormat(start)).getTime()
    const endTime = new Date(convertsDateToIsoFormat(end)).getTime()

    return dateTime >= new Date(startTime) && dateTime <= new Date(endTime);
}

//Получает сегодняшнюю дату в формате ISO yyyy-mm-dd
function getTodayDateInISOFormat() {
    return (new Date()).toISOString().split('T')[0]
}

//Проверка существования даты в формате dd.mm.yyyy
function isValidDate(date) {
    let dd = date.split('.').splice(0, 1).join()
    let mm = date.split('.').splice(1, 1).join()
    const yyyy = parseInt(date.split('.').pop())

    dd = Number(dd > 0 ? dd : dd.slice(0, 1))
    mm = Number(mm > 0 ? mm : mm.slice(0, 1))

    const d = new Date(yyyy, --mm, dd);
    return yyyy === d.getFullYear() && mm === d.getMonth() && dd === d.getDate();
}
